// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"112":"work","594":"about"}[chunkId] + "." + {"112":"86d48461","594":"9eb70b06"}[chunkId] + ".css";
};